import { render, staticRenderFns } from "./ResultadoIsf.vue?vue&type=template&id=303dc38e"
import script from "./ResultadoIsf.vue?vue&type=script&lang=js"
export * from "./ResultadoIsf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports